// @ts-nocheck
import React, { useState } from 'react';
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from 'react-router-dom';

import store from './store';
import { Provider as ReduxProvider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import './theme1.css';
import permissionTypes from './constants/permissionTypes';

import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

import SigninOidc from './components/auth/signin-oidc';
import SignoutOidc from './components/auth/signout-oidc';

import MustAuth from './components/auth/MustAuth';
import BigLoader from './components/layout/BigLoader';
import Layout from './components/Layout';

import Home from './components/home/Home';
import Oops from './components/Oops';
import AccessDenied from './components/AccessDenied';
import ApiFailure from './components/ApiFailure';
import NotFound from './components/NotFound';
import TrialEnded from './components/TrialEnded';

import Companies from './components/company/Companies';
import Company from './components/company/Company';

import Announcements from './components/settings/announcement/Announcements';
import Announcement from './components/settings/announcement/Announcement';

import CompanyTypes from './components/settings/company-type/CompanyTypes';
import CompanyType from './components/settings/company-type/CompanyType';

import Games from './components/game/Games';
import Game from './components/game/Game';
import GameFranchises from './components/game/GameFranchises';


import Promotions from './components/promotion/Promotions';
import PromotionCalendar from './components/promotion/PromotionCalendar';
import Promotion from './components/promotion/Promotion';

import Sku from './components/sku/Sku';

import Settings from './components/settings/Settings';

import Keys from './components/keys/Keys';
import Accounts from './components/keys/Accounts';
import Account from './components/keys/Account';
import ReportedDisabled from './components/keys/ReportedDisabled';
import ReportedActivated from './components/keys/ReportedActivated';
import ReportedSold from './components/keys/ReportedSold';
import IngestedBatches from './components/keys/IngestedBatches';
import BulkIngested from './components/keys/BulkIngested';

import Emails from './components/settings/email/Emails';

import KeyPoolNotifications from './components/settings/key-pool-notification/KeyPoolNotifications';
import KeyPoolNotification from './components/settings/key-pool-notification/KeyPoolNotification';

import PackageTypes from './components/settings/package-type/PackageTypes';
import PackageType from './components/settings/package-type/PackageType';

import Platforms from './components/settings/platform/Platforms';
import Platform from './components/settings/platform/Platform';

import Territories from './components/settings/territory/Territories';
import Territory from './components/settings/territory/Territory';

import KeyProviders from './components/settings/key-provider/KeyProviders';
import KeyProvider from './components/settings/key-provider/KeyProvider';

import Users from './components/settings/users/Users';
import User from './components/settings/users/User';
import UsersInGroup from './components/settings/users/UsersInGroup';

import Workflows from './components/settings/workflow/Workflows';
import Workflow from './components/settings/workflow/Workflow';

import ApproverNotificationUsers from './components/settings/workflow/ApproverNotificationUsers';

import RequestsBySKU from './components/reports/RequestsBySKU';
import RequestsByGame from './components/reports/RequestsByGame';
import RequestsByCompany from './components/reports/RequestsByCompany';
import KeysBySku from './components/reports/KeysBySku';
import KeysByCompany from './components/reports/KeysByCompany';
import SLAsByCompanies from './components/reports/SLAsByCompanies';
import SLAsByGame from './components/reports/SLAsBySku';
import SLAsByWorkflows from './components/reports/SLAsByWorkflows';

import AllowedSkus from './components/settings/territory/AllowedSkus';
import DisallowedSkus from './components/settings/territory/DisallowedSkus';

import Request from './components/requests/Request';
import Requests from './components/requests/Requests';
import RequestsAssignedToMe from './components/requests/RequestsAssignedToMe';
import RequestsMadeByMe from './components/requests/RequestsMadeByMe';
import RequestsToBeApproved from './components/requests/RequestsToBeApproved';
import RequestsBulk from './components/requests/Bulk';

import UserProfileGroup from './components/settings/user-profile-group/UserProfileGroup';
import UserProfileGroups from './components/settings/user-profile-group/UserProfileGroups';

import Uploaders from './components/settings/uploader/Uploaders';

import DisabledReasons from './components/settings/disabled-reasons/DisabledReasons';
import DisabledReason from './components/settings/disabled-reasons/DisabledReason';

import UploadGames from './components/settings/upload-games/UploadGames';
import GameKeys from './components/keys/GameKeys';
import KeyPools from './components/keys/KeyPools';
import ReportedActivatedTransaction from './components/keys/ReportedActivatedTransaction';
import ReportedDisabledTransaction from './components/keys/ReportedDisabledTransaction';
import ReportedSoldTransaction from './components/keys/ReportedSoldTransaction';
import IngestedTransaction from './components/keys/IngestedTransaction';
import Permissions from './components/settings/permissions/Permissions';
import SilentRenewOidc from './components/auth/silent-renew-oidc';
import KeySearch from './components/keys/KeySearch';
import userTypes from './constants/userTypes';
import { ErrorBoundary } from 'react-error-boundary';
import DownloadKeyCode from './components/public/DownloadKeyCode';
import MovedTransactions from './components/keys/MovedTransactions';
import MovedTransaction from './components/keys/MovedTransaction';
import MoveKeysBetweenRequests from './components/keys/MoveKeysBetweenRequests';
import RequestsByAuthorisingUser from './components/reports/RequestsByAuthorisingUser';
import RequestsByUploadingUser from './components/reports/RequestsByUploadingUser';
import WorkflowsByRequesters from './components/reports/WorkflowsByRequesters';
import WorkflowsByApprovers from './components/reports/WorkflowsByApprovers';
import KeysByGame from './components/reports/KeysByGame';
import PromotionsGrid from './components/promotion/PromotionsGrid';
import KeysByUploadingUser from './components/reports/KeysByUploadingUser';
import KeysByAuthorisingUser from './components/reports/KeysByAuthorisingUser';
import UsersModifiedByUser from './components/reports/UsersModifiedByUser';
import KeyWorkflowsModifiedByUser from './components/reports/KeyWorkflowsModifiedByUser';
import GamesModifiedByUser from './components/reports/GamesModifiedByUser';
import SKUsModifiedByUser from './components/reports/SKUsModifiedByUser';
import RequestsByWorkflow from './components/reports/RequestsByWorkflow';
import KeysByWorkflow from './components/reports/KeysByWorkflow';
import HealthChecks from './components/settings/health-check/HealthChecks';
import KeysByCompanyByStatus from './components/reports/KeysByCompanyByStatus';
import KeysByCompanyByTagByStatus from './components/reports/KeysByCompanyByTagByStatus';
import PricingGrid from './components/skuPricing/PricingGrid';
import UploadPricing from './components/skuPricing/UploadPricing';
import HasPermission from './components/auth/hasPermission';
import PrivateRoute from './components/auth/PrivateRoute';

config.autoAddCss = false;

const App = () => {
  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? '/';
  const [classes, setClasses] = useState();
  const [completeRequestSlideoutOpen, setCompleteRequestSlideoutOpen] =
    useState(false);

  return (
    <ReduxProvider store={store}>
      <BrowserRouter basename={baseUrl}>
        <ErrorBoundary FallbackComponent={Oops}>
          <Routes>
            <Route path="/not-found" element={<NotFound />} />

            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/error" element={<Oops />} />
            <Route path="/api-failure" element={<ApiFailure />} />
            <Route path="/trial-ended" element={<TrialEnded />} />
            <Route path="/signout-oidc" element={<SignoutOidc />} />
            <Route path="/signin-oidc" element={<SigninOidc />} />
            <Route path="/silent-renew-oidc" element={<SilentRenewOidc />} />
            <Route
              path="/download-key-code/:keyRequestId/:accountId"
              element={<DownloadKeyCode />}
            />

            <Route
              path="/*"
              element={
                <MustAuth>
                  <Layout
                    classes={classes}
                    completeRequestSlideoutOpen={completeRequestSlideoutOpen}
                    setCompleteRequestSlideoutOpen={
                      setCompleteRequestSlideoutOpen
                    }
                  >
                    <ToastContainer
                      icon={false}
                      autoClose={3000}
                      hideProgressBar
                      position="top-center"
                    />
                    <Outlet /> {/* Placeholder for nested routes */}
                  </Layout>
                </MustAuth>
              }
            >
              <Route
                index
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="games"
                element={
                  <PrivateRoute>
                    <Games
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="game/add"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_GAMES]}
                  >
                    <Game />
                  </PrivateRoute>
                }
              />
              <Route
                path="game/:id"
                element={
                  <PrivateRoute>
                    <Game
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="sku/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Sku
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route path="franchises" element={
                <PrivateRoute>
                  <GameFranchises />
                </PrivateRoute>
              } />
              <Route
                path="request/:id"
                element={
                  <PrivateRoute>
                    <Request
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests"
                element={
                  <PrivateRoute>
                    <Requests />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests/all"
                element={
                  <PrivateRoute>
                    <Requests
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests/assigned-to-me"
                element={
                  <PrivateRoute
                    allowedUserTypes={[userTypes.APPROVER, userTypes.UPLOADER]}
                  >
                    <RequestsAssignedToMe
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests/made-by-me"
                element={
                  <PrivateRoute allowedUserTypes={[userTypes.REQUESTER]}>
                    <RequestsMadeByMe
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests/approve"
                element={
                  <PrivateRoute allowedUserTypes={[userTypes.APPROVER]}>
                    <RequestsToBeApproved
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="requests/bulk"
                element={
                  <PrivateRoute allowedUserTypes={[userTypes.REQUESTER]}>
                    <RequestsBulk
                      setClasses={setClasses}
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="companies"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_COMPANIES]}
                  >
                    <Companies />
                  </PrivateRoute>
                }
              />
              <Route
                path="companies-archived"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_COMPANIES]}
                  >
                    <Companies />
                  </PrivateRoute>
                }
              />
              <Route
                path="promotions/all"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_PROMOTIONS,
                      permissionTypes.VIEW_PROMOTIONS,
                    ]}
                  >
                    <Promotions />
                  </PrivateRoute>
                }
              />
              <Route
                path="promotions/grid"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_PROMOTIONS,
                      permissionTypes.VIEW_PROMOTIONS,
                    ]}
                  >
                    <PromotionsGrid setClasses={setClasses} />
                  </PrivateRoute>
                }
              />
              <Route
                path="promotions"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_PROMOTIONS,
                      permissionTypes.VIEW_PROMOTIONS,
                    ]}
                  >
                    <PromotionCalendar />
                  </PrivateRoute>
                }
              />
              <Route
                path="promotion/add"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_PROMOTIONS]}
                  >
                    <Promotion />
                  </PrivateRoute>
                }
              />
              <Route
                path="promotion/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_PROMOTIONS,
                      permissionTypes.VIEW_PROMOTIONS,
                    ]}
                  >
                    <Promotion />
                  </PrivateRoute>
                }
              />

              <Route
                path="pricing/all"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_PRICING,
                      permissionTypes.VIEW_PRICING,
                    ]}
                  >
                    <PricingGrid setClasses={setClasses} />
                  </PrivateRoute>
                }
              />
              <Route
                path="pricing/upload"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_PRICING]}
                  >
                    <UploadPricing setClasses={setClasses} />
                  </PrivateRoute>
                }
              />

              <Route
                path="company/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_COMPANIES]}
                    allowedUserTypes={[
                      userTypes.UPLOADER,
                      userTypes.APPROVER,
                      userTypes.ADMIN,
                    ]}
                  >
                    <Company
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/search"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.KEYS_SEARCH,
                    ]}
                  >
                    <KeySearch />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/account/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.KEYS_SEARCH,
                    ]}
                  >
                    <Account />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/accounts"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.KEYS_SEARCH,
                    ]}
                  >
                    <Accounts />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/game"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <GameKeys />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/pools"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <KeyPools />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-sold/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_SOLD
                    ]}
                  >
                    <ReportedSoldTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-sold"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_SOLD]}
                  >
                    <ReportedSold />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/moved/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <MovedTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/moved"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <MovedTransactions />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/move-between-requests"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <MoveKeysBetweenRequests />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-activated/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_ACTIVATIONS
                    ]}
                  >
                    <ReportedActivatedTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-activated"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_ACTIVATIONS]}
                  >
                    <ReportedActivated />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-disabled/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_DISABLED
                    ]}
                  >
                    <ReportedDisabledTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/reported-disabled"
                element={
                  <PrivateRoute
                    allowedPermissions={[
                      permissionTypes.MANAGE_KEYS,
                      permissionTypes.UPLOAD_DISABLED
                    ]}
                  >
                    <ReportedDisabled />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/ingested-batches/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <IngestedTransaction />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/ingested-batches"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <IngestedBatches />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys/bulk-ingest"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_KEYS]}
                  >
                    <BulkIngested />
                  </PrivateRoute>
                }
              />
              <Route
                path="keys"
                element={
                  <PrivateRoute
                    allowedUserTypes={[
                      userTypes.REQUESTER,
                      userTypes.UPLOADER,
                      userTypes.APPROVER,
                      userTypes.ADMIN,
                    ]}
                  >
                    <Keys />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/monthly"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/emails"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <Emails />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/approver-notification-users"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_WORKFLOWS]}
                  >
                    <ApproverNotificationUsers />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/workflows"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_WORKFLOWS]}
                  >
                    <Workflows />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/workflow/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_WORKFLOWS]}
                  >
                    <Workflow />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/disabled-reasons"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <DisabledReasons />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/disabled-reason/:id"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <DisabledReason />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/key-pool-notifications"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <KeyPoolNotifications />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/key-pool-notification/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <KeyPoolNotification />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/user-profile-group/:id/members"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <UsersInGroup />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/user-profile-group/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <UserProfileGroup />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/user-profile-groups"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_USERS]}
                  >
                    <UserProfileGroups />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/uploaders"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_USERS]}
                  >
                    <Uploaders />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/permissions"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_PERMISSIONS]}
                  >
                    <Permissions />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/territories"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_TERRITORIES]}
                  >
                    <Territories />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/territory/allowed-skus/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <AllowedSkus />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/territory/disallowed-skus/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <DisallowedSkus />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/territory/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Territory />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/key-providers"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <KeyProviders />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/key-provider/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <KeyProvider />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/package-types"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <PackageTypes />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/announcement/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Announcement />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/announcements"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_SETTINGS]}
                  >
                    <Announcements />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/company-type/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <CompanyType />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/company-types"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_COMPANIES]}
                  >
                    <CompanyTypes />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/package-type/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <PackageType />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/platforms"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_PLATFORMS]}
                  >
                    <Platforms />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/platform/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Platform />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/upload-games"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.MANAGE_GAMES]}
                  >
                    <UploadGames setClasses={setClasses} />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/users"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Users />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/user/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <User
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings/health-checks"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <HealthChecks />
                  </PrivateRoute>
                }
              />
              <Route
                path="settings"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Settings setClasses={setClasses} />
                  </PrivateRoute>
                }
              />
              <Route
                path="users"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Users />
                  </PrivateRoute>
                }
              />
              <Route
                path="users-archived"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <Users />
                  </PrivateRoute>
                }
              />
              <Route
                path="user/:id"
                element={
                  <PrivateRoute isPowerUser={true}>
                    <User
                      setCompleteRequestSlideoutOpen={
                        setCompleteRequestSlideoutOpen
                      }
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-by-sku"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsBySKU />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-by-game"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsByGame />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-by-workflow"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsByWorkflow />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-game"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByGame />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-workflow"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByWorkflow />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-sku"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysBySku />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-company"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByCompany />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-company-by-status"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByCompanyByStatus />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-by-company-by-tag-by-status"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByCompanyByTagByStatus />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-by-company"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsByCompany />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-authorising-user"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsByAuthorisingUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-authorising-user"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByAuthorisingUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/requests-uploading-user"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <RequestsByUploadingUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keys-uploading-user"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeysByUploadingUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/workflows-requesters"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <WorkflowsByRequesters />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/workflows-approvers"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <WorkflowsByApprovers />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/sla-company"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <SLAsByCompanies />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/sla-sku"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <SLAsByGame />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/sla-workflow"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <SLAsByWorkflows />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/games-added"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <GamesModifiedByUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/skus-added"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <SKUsModifiedByUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/users-added"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <UsersModifiedByUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="reports/keyworkflows-added"
                element={
                  <PrivateRoute
                    allowedPermissions={[permissionTypes.VIEW_REPORTS]}
                  >
                    <KeyWorkflowsModifiedByUser />
                  </PrivateRoute>
                }
              />
              <Route
                path="auth/hasPermission"
                element={
                  <PrivateRoute>
                    <HasPermission />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
          <BigLoader />
        </ErrorBoundary>
      </BrowserRouter>
    </ReduxProvider>
  );
};

export default App;
